import { RasaContext } from 'context'
import * as Flash from 'components/flash'
import * as GenericRedux from 'generic/genericRedux'
import { RasaReactComponent } from 'generic/rasaReactComponent'
import React from 'react'
import './styles.scss'
import './stripo.scss'
import { SharedKeys, SharedStore } from 'shared/data-layer/sharedStore'
import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'
import { Loading } from 'components/loading'
import { DATE_FORMATS, DATE_TIME_FORMATS, EmailAttributes, getAttribute, getDateFormatOptions } from './constants'
import { StripoDefaultTemplates } from 'shared_server_client/constants'
import { Roles } from 'shared/constants'
import { BaseClientEntity } from 'generic/baseClientEntity'
import { getAllTextLocationsOptions, getBannerImageLocationOptions, getSquareImageLocationsOptions } from 'shared_server_client/utils'
import { Dataset } from 'generic/dataset'
import * as Query from 'query-string'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { BillingPlanDetailCode } from 'shared_server_client/types/billing_plan'

type StripoState = {
  configs: any,
  communityId: string,
  templateCommunityIdentifier: string,
  emailLayoutId: string,
  emailLayout: any,
  hasTopicPreferenceAccess: boolean,
  isDirty: boolean,
  isLoading: boolean,
  isSaving: boolean,
  isSuperUser: boolean,
  maxSponsoredPosts: number,
  showSaveTemplateModal: boolean,
  templateName: string,
  originalTemplateName: string,
}

type StripoProps = GenericRedux.AllComponentProps<any>

interface InitPluginOptions {
  template: any;
  emailLayout: any;
  getRasaImageUrl: (imageUrl: string) => Promise<any>;
  setRasaConfigValue: (key: string, value: any) => void;
  bannerLocationOptions: any[];
  squareLocationOptions: any[];
  textLocationOptions: any[];
  sections: any[];
  communityId: string;
  maxSponsoredPosts: number;
  userEmail?: string;
  accountId?: string;
  userFullName?: string;
}

declare const window: {
  location: any;
  Stripo?: any;
  StripoApi?: any;
};
declare const RASA_ASSETS_CDN: string

// Extension modules for regular newsletter templates
const NEWSLETTER_EXTENSIONS = [
  { globalName: "HeaderExtension" },
  { globalName: "BannerExtension" },
  { globalName: "SquareExtension" },
  { globalName: "ArticleStructureExtension" },
  { globalName: "EventStructureExtension" },
  { globalName: "SponsoredStructureExtension" },
  { globalName: "FooterExtension" },
  { globalName: "TextExtension" },
  { globalName: "ViewInBrowserExtension" },
  { globalName: "SponsoredExtension" },
  { globalName: "ArticleExtension" },
  { globalName: "EventExtension" },
  { globalName: "SurveyExtension" },
]

// Extension modules for blast templates
const BLAST_EXTENSIONS = [
  // currently use empty array to use just built-in stripo extensions
  // { globalName: "Footer1Extension" },
]

const getAuthToken = (communityId, callback) => {
  const url: string = AjaxWrapper.getServerUrl() + `/stripo/auth/${communityId}`
  AjaxWrapper.xmlRequest(url, HttpMethod.GET, {}, function(data) {
    callback(JSON.parse(data).token)
  })
}

export class StripoEditorComponent extends RasaReactComponent<StripoProps, StripoState> {
  public static contextType = RasaContext
  private sharedStore: SharedStore
  private isBlastTemplate: boolean
  constructor(props: any) {
    super(props, 'stripoHtmlTemplates')
    const queryParams = Query.parse(location.search)
    this.state = {
      communityId: "",
      templateCommunityIdentifier: queryParams.communityIdentifier ? String(queryParams.communityIdentifier) : "",
      configs: {},
      emailLayout: {},
      emailLayoutId: "",
      hasTopicPreferenceAccess: false,
      isDirty: false,
      isLoading: false,
      isSaving: false,
      isSuperUser: false,
      maxSponsoredPosts: 0,
      showSaveTemplateModal: false,
      templateName: queryParams.template ? String(queryParams.template): "",
      originalTemplateName: "",
    }
    this.isBlastTemplate = queryParams.type === 'blast'
    this.getAndSaveTemplate = this.getAndSaveTemplate.bind(this)
    this.getRasaImageURL = this.getRasaImageURL.bind(this)
    this.setRasaConfigValue = this.setRasaConfigValue.bind(this)
    this.saveConfigs = this.saveConfigs.bind(this)
    this.loadTemplates = this.loadTemplates.bind(this)
    this.saveVersionHistoryPoint = this.saveVersionHistoryPoint.bind(this)
  }

  public componentDidMount = () => {
    document.getElementById('saveButton').style.display = 'none';
    document.getElementById('changeHistoryLink').style.display = 'none';

    this.sharedStore = SharedStore.instance(this.context)
    Promise.all([
      this.sharedStore.getValue(SharedKeys.activeCommunity),
      this.sharedStore.getValue(SharedKeys.person),
      this.sharedStore.getValue(SharedKeys.role),
    ]).then(([activeCommunity, person, role]) => {
      const sponsoredFeature: any = activeCommunity.billingInfo.currentPlan.details.find((x) =>
        x.billing_plan_code === BillingPlanDetailCode.MAX_SPONSORED_POSTS)
      const topicPreferenceFeature: any = activeCommunity.billingInfo.currentPlan.details.find((x) =>
        x.billing_plan_code === BillingPlanDetailCode.TOPIC_PREFERENCES)
      this.setState({
        communityId: activeCommunity.communityId,
        emailLayoutId: activeCommunity.communityInfo.data.email_layouts.filter((s: any) => s.is_active)[0].id,
        hasTopicPreferenceAccess: topicPreferenceFeature && topicPreferenceFeature.limit_val !== 0,
        maxSponsoredPosts: sponsoredFeature ? sponsoredFeature.limit_val : 0,
        isSuperUser: role === Roles.super_admin,
      }, () => {
        this.loadTemplates(activeCommunity, person)
      })
    })
  }


  public render() {
    return <div className="stripo">
      <div>
        <div className="stripo-settings-container">
          <div id="stripoSettingsContainer">
            <Loading size="64" />
          </div>
        {this.state.isSaving ? <Loading size="32" />:
          <div className="stripo-settings-actions">
            <div id="saveButtonContainer">
              <button disabled={this.state.isLoading} id="saveButton" onClick={this.showTemplateModal} className="control-button">Save</button>
            </div>
            <div id='changeHistoryContainer'>
              <button disabled={this.state.isLoading} id="changeHistoryLink" className="control-button">Version History</button>
             </div>
          </div>}
        </div>
        <div id="stripoPreviewContainer"></div>
        <div id="externalSystemContainer">
        {this.renderSaveTemplateModal()}
      </div>
      </div>
      <div className="notification-zone"></div>
    </div>
  }

  public getRasaImageURL = (imageUrl) => {
    const imageValidateEndpoint: string =  `${AjaxWrapper.getServerUrl()}/${this.state.communityId}/gallery/source`
    return AjaxWrapper.ajax(imageValidateEndpoint, HttpMethod.POST, {imageUrl})
  }

  public setRasaConfigValue = (key, value) => {
    this.setState({
      configs: {
        ...this.state.configs,
        [key]: value
      }
    })
  }

  private saveConfigs = () => {
    this.context.entityMetadata.getEntityObject('email_layout', this.state.communityId, this.state.emailLayoutId)
      .then((emailLayoutEntityObject: BaseClientEntity) => {
        Object.keys(this.state.configs).forEach((key) => {
          const value = this.state.configs[key]
          emailLayoutEntityObject.data[key] = value
        })
        emailLayoutEntityObject.save()
      })
      .catch()
  }

  private getEmailLayoutInfo = () => {
    return this.context.entityMetadata.getEntityObject('email_layout').then(
      (entityObject: any ) => {
      return new Promise ((resolve, reject) => {
        entityObject.load(this.state.communityId, this.state.emailLayoutId).then(() => {
        this.setState({
          emailLayout: {
            ...entityObject.data,
          }
        }, () => {
          resolve(entityObject.data)
        })
      })
      })
    })
  }

  private getSections = (community) => {
    return new Dataset()
    .loadCommunityDataset('sections', community)
    .then((response) => {
      return this.normalizeSections(response[0] || [])
    })
  }

  private normalizeSections = (sections) => {
    const normalizedSections = sections.map((s) => ({
      description: s.display_name,
      key: s.display_name,
      value: s.name,
    }))
    if (sections.length) {
      normalizedSections.unshift({
        description: 'No section',
        key: 'No Section',
        value: '',
      })
    }
    return normalizedSections
  }

  private loadTemplates = (activeCommunity, person) => {
    this.getEmailLayoutInfo().then((emailLayout: any) => {
      const templateName = this.state.templateName || emailLayout[EmailAttributes.emailTemplate]
      this.setState({ originalTemplateName: templateName })
      // Use templateCommunityIdentifier from query params if provided, otherwise use activeCommunity.communityId
      const communityIdForTemplate = this.state.templateCommunityIdentifier || activeCommunity.communityId
      const url: string = AjaxWrapper.getServerUrl() + `/stripo/templates/${communityIdForTemplate}?templateName=${templateName}`
      Promise.all([
        AjaxWrapper.ajax(url, HttpMethod.GET, {}),
        getBannerImageLocationOptions(),
        getSquareImageLocationsOptions(),
        getAllTextLocationsOptions(),
        this.getSections(activeCommunity.communityId),
      ]).then(([template, bannerLocationOptions, squareLocationOptions, textLocationOptions, sections]) => {
        this.initPlugin({
          template,
          emailLayout,
          getRasaImageUrl: this.getRasaImageURL,
          setRasaConfigValue: this.setRasaConfigValue,
          bannerLocationOptions,
          squareLocationOptions,
          textLocationOptions,
          sections,
          communityId: this.state.communityId,
          maxSponsoredPosts: this.state.maxSponsoredPosts,
          userEmail: person.email,
          accountId: activeCommunity.data.account_id,
          userFullName: person.fullName
        })
      })
    })
  }

  private renderSaveTemplateModal(): JSX.Element {
    return (
      <div>
        <Modal isOpen={this.state.showSaveTemplateModal}>
          <ModalHeader>
            Name Your Template
          </ModalHeader>
          <ModalBody className='save-template-modal-body'>
            <div>
                <input
                  className='template-name-input'
                  type="text"
                  value={this.state.templateName}
                  onChange={(e) => this.setState({templateName: this.sanitizeTemplateName(e.target.value)})}
                  placeholder="Enter template name"
                />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => this.saveTemplate()}>
              Save
            </Button>
            <Button onClick={() => this.setState({
              showSaveTemplateModal: false
            })}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }

  private showTemplateModal = () => {
    // For blast templates, skip the modal and save directly
    if (this.isBlastTemplate) {
      this.saveTemplate()
    } else {
      this.setState({
        showSaveTemplateModal: true
      })
    }
  }

  private sanitizeTemplateName = (input: string): string => {
    // Remove characters that are not allowed in S3 file names:
    // - Forward slash (/) and backslash (\) - create directory structure
    // - Less than (<), greater than (>) - can cause issues
    // - Colon (:), pipe (|), question mark (?), asterisk (*) - reserved characters
    // - Quote (") - can cause escaping issues
    // - Control characters (0x00-0x1f) - non-printable characters
    return input.replace(/[\/\\<>:"|?*\x00-\x1f]/g, '')
  }

  private saveTemplate = () => {
    this.setState({
      isSaving: true,
      showSaveTemplateModal: false,
    })

    // Skip version history if original template name is a default template (first time saving)
    if (Object.values(StripoDefaultTemplates).includes(this.state.originalTemplateName as StripoDefaultTemplates)) {
      window.StripoApi.getTemplate(this.getAndSaveTemplate)
      this.saveConfigs()
    } else {
      // Create version history point before saving
      this.saveVersionHistoryPoint(() => {
        window.StripoApi.getTemplate(this.getAndSaveTemplate)
        this.saveConfigs()
      })
    }
  }

  private saveVersionHistoryPoint = (onSaveCallback) => {
    if (window.StripoApi.createVersionHistoryPointAsync) {
      window.StripoApi.createVersionHistoryPointAsync(onSaveCallback);
    } else {
      // Deprecated
      window.StripoApi.createVersionHistoryPoint();
      onSaveCallback();
    }
  }


  private getAndSaveTemplate = (html, css) => {
    // Use templateCommunityIdentifier if provided (for templates from other newsletters), otherwise use current communityId
    const communityIdForSave = this.state.templateCommunityIdentifier || this.state.communityId
    const url: string = AjaxWrapper.getServerUrl() + `/stripo/templates/${communityIdForSave}`
    return AjaxWrapper.ajax(url, HttpMethod.POST, {
      html,
      css,
      filename: this.state.templateName,
    }).then((template) => {
      this.setState({
        isSaving: false,
      })
      this.context.store.dispatch(Flash.showFlashMessage('Template saved successfully.'))
      // Update URL with new template name and reload to ensure version history works properly
      setTimeout(() => {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('template', this.state.templateName);
        window.location.href = newUrl.toString();
      }, 1000)
    }).catch((error) => {
      this.setState({
        isSaving: false,
      })
      this.context.store.dispatch(Flash.showFlashMessage('Failed to save template. Please try again.'))
    })
  }

  private initPlugin(options: InitPluginOptions) {
    const dateFormats = DATE_FORMATS
    if (!dateFormats.includes(getAttribute(options.emailLayout, EmailAttributes.headerDateFormat))) {
      dateFormats.push(getAttribute(options.emailLayout, EmailAttributes.headerDateFormat))
    }
    const dateTimeFormats = DATE_TIME_FORMATS
    if (!dateTimeFormats.includes(getAttribute(options.emailLayout, EmailAttributes.eventDateFormat))) {
      dateTimeFormats.push(getAttribute(options.emailLayout, EmailAttributes.eventDateFormat))
    }
    const templateName = this.state.templateName || getAttribute(options.emailLayout, EmailAttributes.emailTemplate) || 'default_template'
    const sanitizedTemplateName = templateName.replace(/\s+/g, '_')
    const apiRequestData = {
      emailId: `${options.communityId}_${sanitizedTemplateName}`,
      accountId: options.accountId || '000000',
      communityId: options.communityId,
    };
    const script = document.createElement('script');
    const controlsToRemove = [
      'messageAlignAppearanceControl',
      'generalBackgroundImageAppearanceControl',
      'headerBackgroundImageAppearanceControl',
      'footerBackgroundImageAppearanceControl',
      'headerContentBackgroundColorAppearanceControl',
    ]
    const MAX_EMAIL_WIDTH = 728
    script.id = 'stripoScript';
    script.type = 'text/javascript';
    script.src = 'https://plugins.stripo.email/static/latest/stripo.js';
    const originalTemplateName = this.state.originalTemplateName;
    const hasTopicPreferenceAccess = this.state.hasTopicPreferenceAccess;
    const isBlastTemplate = this.isBlastTemplate;
    script.onload = function () {
      if (!window.Stripo ) {
        return
      }
      // eslint-disable-next-line no-undef
      window.Stripo.init({
        settingsId: 'stripoSettingsContainer',
        previewId: 'stripoPreviewContainer',
        codeEditorButtonId: 'codeEditor ',
        undoButtonId: 'undoButton',
        redoButtonId: 'redoButton',
        locale: 'en',
        html: options.template.html,
        css: options.template.css,
        apiRequestData,
        enableOutlookDesktopCommentHidingFix: false,
        supportOutlookButtonsByDefault: true,
        userFullName: options.userFullName || 'Plugin Demo User',
        settingsPanelBlockSortFunc: (names: any[]) => {
          const rasaBlocks = names.filter((x) => x.startsWith('esd-extension'))
          const otherBlocks = names.filter((x) => !x.startsWith('esd-extension'))
          return [...rasaBlocks, ...otherBlocks]
        },
        versionHistory: {
          changeHistoryLinkId: 'changeHistoryLink',
          onInitialized: (lastChangeInfoText) => {
            document.getElementById('saveButton').style.display = 'inline';
            const button = document.getElementById('changeHistoryLink');
            if (button) {
              document.getElementById('changeHistoryLink').innerHTML = 'Version History';
              // Hide version history button if this is the first time (original template is a default template)
              if (Object.values(StripoDefaultTemplates).includes(originalTemplateName as StripoDefaultTemplates)) {
                button.style.display = 'none';
              } else {
                button.style.display = 'inline';
              }
            }
          }
        },
        "socialNetworks": [
          {
            "name": "twitter",
            "href": ""
          },
          {
            "name": "facebook",
            "href": ""
          },
          {
            "name": "linkedin",
            "href": ""
          },
          {
            "name": "instagram",
            "href": ""
          },
          {
            "name": "youtube",
            "href": ""
          }
        ],
        "extensions": (() => {
          if (isBlastTemplate) {
            return BLAST_EXTENSIONS.map(ext => ({
              ...ext,
              url: `${RASA_ASSETS_CDN}/stripo/rasa-stripo-extensions.js`,
            }))
          }

          // For newsletter templates, build extensions array with TopicPreferenceExtension in the correct position
          const extensions = NEWSLETTER_EXTENSIONS.map(ext => ({
            ...ext,
            url: `${RASA_ASSETS_CDN}/stripo/rasa-stripo-extensions.js`,
          }))

          // Insert TopicPreferenceExtension after TextExtension if user has access
          if (hasTopicPreferenceAccess) {
            const textExtensionIndex = extensions.findIndex(ext => ext.globalName === "TextExtension")
            const insertIndex = textExtensionIndex !== -1 ? textExtensionIndex + 1 : extensions.length
            extensions.splice(insertIndex, 0, {
              "globalName": "TopicPreferenceExtension",
              "url": `${RASA_ASSETS_CDN}/stripo/rasa-stripo-extensions.js`,
            })
          }

          return extensions
        })(),
       "rasaCallbacks": {
        getRasaImageUrl: options.getRasaImageUrl,
        setRasaConfigValue: options.setRasaConfigValue
      },
      emailLayout: options.emailLayout,
       "headerBlock": {
          "enabled": true,
          "brand_header_image_url": getAttribute(options.emailLayout, EmailAttributes.brandHeaderImageUrl),
          "brand_header_alt_text": getAttribute(options.emailLayout, EmailAttributes.brandHeaderAltText),
          "dateFormatOptions": getDateFormatOptions(dateFormats),
          "header_date_format": getAttribute(options.emailLayout, EmailAttributes.headerDateFormat),
          "show_subscribe_url_in_header": getAttribute(options.emailLayout, EmailAttributes.showSubscribeUrlInHeader),
          "show_unsubscribe_url_in_header": getAttribute(options.emailLayout, EmailAttributes.showUnsubscribeUrlInHeader),
       },
       "bannerBlock": {
          "enabled": true,
          "locationOptions": options.bannerLocationOptions,
        },
        "squareBlock": {
          "enabled": true,
          "locationOptions": options.squareLocationOptions,
        },
        "articleBlock": {
          "enabled": true,
          "sectionOptions": options.sections,
        },
        "eventBlock": {
          "enabled": true,
          "event_date_format": getAttribute(options.emailLayout, EmailAttributes.eventDateFormat),
          "dateTimeFormatOptions": getDateFormatOptions(dateTimeFormats),
          "sectionOptions": options.sections,
        },
        "sponsoredBlock": {
          "enabled": true,
          maxSponsoredPosts: options.maxSponsoredPosts,
        },
        "footerBlock": {
          "enabled": true,
          "show_rasa_logo": getAttribute(options.emailLayout, EmailAttributes.showRasaLogo),
        },
        "textBlock": {
          "enabled": true,
          "locationOptions": options.textLocationOptions,
        },
        "surveyBlock": {
          "enabled": true,
        },
        "viewInBrowserBlock": {
          "enabled": true,
        },
        ...(hasTopicPreferenceAccess ? {
          "topicPreferenceBlock": {
            "enabled": true,
          },
        } : {}),
        getAuthToken: (callback) => {
          getAuthToken(options.communityId, callback)
        }
      }, () => {
        const removeDefaultControl = (rawControls, controlNameToRemove) => rawControls.splice(rawControls.indexOf(rawControls.find(c => c.name === controlNameToRemove)), 1);
        window.StripoApi.initExternalSettingAppearanceControls = function(rawControls) {
          // Remove default Appearance 'Message alignment' control
          controlsToRemove.forEach(controlNameToRemove => removeDefaultControl(rawControls, controlNameToRemove));
          rawControls.find((x) => x.name === "emailWidthAppearanceControl").getMaxValue = () => { return MAX_EMAIL_WIDTH }
      }
      });
    };
    document.body.appendChild(script);
  }

}

export const StripoEditor = GenericRedux.registerNewComponent<any>(
  StripoEditorComponent,
  'stripo',
  {})
